import { combineReducers } from 'redux';
import appReducer from './appReducer';
import userReducer from './userReducer';
import empresaReducer from './empresaReducer';
import proyectoReducer from './proyectoReducer';
import elementoReducer from './elementoReducer';
import usuarioReducer from './usuarioReducer';
import sensorReducer from './sensorReducer';
import tarjetaReducer from './tarjetaReducer';
import graficaReducer from './graficaReducer';
import dashboardReducer from './dashboardReducer';
import dashboardV2Reducer from './dashboardV2Reducer';
import { LOGOUT } from '../actions/types';
import { removeTokens } from '../services/api';
import objetivoReducer from './objetivoReducer';
import reporteReducer from './reporteReducer';
import logsReducer from './logsReducer';
import privilegiosReducer from './privilegiosReducer';
import dispositivosReducer from './dispositivosReducer';

const MainReducer = combineReducers({
  appReducer,
  userReducer,
  empresaReducer,
  proyectoReducer,
  elementoReducer,
  usuarioReducer,
  sensorReducer,
  tarjetaReducer,
  graficaReducer,
  dashboardReducer,
  dashboardV2Reducer,
  objetivoReducer,
  reporteReducer,
  logsReducer,
  privilegiosReducer,
  dispositivosReducer,
});
const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    removeTokens();
  }
  return MainReducer(state, action);
};
export default rootReducer;
